import React from 'react';
import './_SueItemUpdate.css';

interface Props {
    sueData: any;
    onParticipantWitnessChange: (e: any, participantWitness: string, paramName: string, onlyNumbers?: boolean) => void;
}

const VictimsAndWitnesses = (props: Props) => {
    return (
        <div className='white-block white-block-fixed-height'>
            <section className=''>
                <div className='section-sue-title'>
                    פרטי נפגעים ברכב המבוטח ו/או הולכי רגל
                </div>
                {/*
                make this line dynamic, so it can be used for more participants 
                when click on + add new participant limited to 6 participants */}
                <div className="parameter-row">
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                שם הנפגע
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.participant1 && props.sueData.participant1.name} onChange={(e: any) => props.onParticipantWitnessChange(e, 'participant1', 'name')} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                כתובת
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.participant1 && props.sueData.participant1.address} onChange={(e: any) => props.onParticipantWitnessChange(e, 'participant1', 'address')} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                גיל
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.participant1 && props.sueData.participant1.age} onChange={(e: any) => props.onParticipantWitnessChange(e, 'participant1', 'age', true)} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                מס' ת.ז.
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.participant1 && props.sueData.participant1.identityNumber} onChange={(e: any) => props.onParticipantWitnessChange(e, 'participant1', 'identityNumber', true)} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                טלפון
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.participant1 && props.sueData.participant1.phone} onChange={(e: any) => props.onParticipantWitnessChange(e, 'participant1', 'phone', true)} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                אם אושפז שם ב"ח
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.participant1 && props.sueData.participant1.hospitalName} onChange={(e: any) => props.onParticipantWitnessChange(e, 'participant1', 'hospitalName')} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                </div>
                
                
                <div className="parameter-row">
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.participant2 && props.sueData.participant2.name} onChange={(e: any) => props.onParticipantWitnessChange(e, 'participant2', 'name')} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">

                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.participant2 && props.sueData.participant2.address} onChange={(e: any) => props.onParticipantWitnessChange(e, 'participant2', 'address')} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.participant2 && props.sueData.participant2.age} onChange={(e: any) => props.onParticipantWitnessChange(e, 'participant2', 'age', true)} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.participant2 && props.sueData.participant2.identityNumber} onChange={(e: any) => props.onParticipantWitnessChange(e, 'participant2', 'identityNumber', true)} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">

                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.participant2 && props.sueData.participant2.phone} onChange={(e: any) => props.onParticipantWitnessChange(e, 'participant2', 'phone', true)} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.participant2 && props.sueData.participant2.hospitalName} onChange={(e: any) => props.onParticipantWitnessChange(e, 'participant2', 'hospitalName')} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="parameter-row">
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.participant3 && props.sueData.participant3.name} onChange={(e: any) => props.onParticipantWitnessChange(e, 'participant3', 'name')} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">

                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.participant3 && props.sueData.participant3.address} onChange={(e: any) => props.onParticipantWitnessChange(e, 'participant3', 'address')} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.participant3 && props.sueData.participant3.age} onChange={(e: any) => props.onParticipantWitnessChange(e, 'participant3', 'age', true)} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.participant3 && props.sueData.participant3.identityNumber} onChange={(e: any) => props.onParticipantWitnessChange(e, 'participant3', 'identityNumber', true)} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">

                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.participant3 && props.sueData.participant3.phone} onChange={(e: any) => props.onParticipantWitnessChange(e, 'participant3', 'phone', true)} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.participant3 && props.sueData.participant3.hospitalName} onChange={(e: any) => props.onParticipantWitnessChange(e, 'participant3', 'hospitalName')} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="parameter-row">
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.participant4 && props.sueData.participant4.name} onChange={(e: any) => props.onParticipantWitnessChange(e, 'participant4', 'name')} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">

                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.participant4 && props.sueData.participant4.address} onChange={(e: any) => props.onParticipantWitnessChange(e, 'participant4', 'address')} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.participant4 && props.sueData.participant4.age} onChange={(e: any) => props.onParticipantWitnessChange(e, 'participant4', 'age', true)} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.participant4 && props.sueData.participant4.identityNumber} onChange={(e: any) => props.onParticipantWitnessChange(e, 'participant4', 'identityNumber', true)} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">

                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.participant4 && props.sueData.participant4.phone} onChange={(e: any) => props.onParticipantWitnessChange(e, 'participant4', 'phone', true)} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.participant4 && props.sueData.participant4.hospitalName} onChange={(e: any) => props.onParticipantWitnessChange(e, 'participant4', 'hospitalName')} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="parameter-row">
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.participant5 && props.sueData.participant5.name} onChange={(e: any) => props.onParticipantWitnessChange(e, 'participant5', 'name')} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">

                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.participant5 && props.sueData.participant5.address} onChange={(e: any) => props.onParticipantWitnessChange(e, 'participant5', 'address')} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.participant5 && props.sueData.participant5.age} onChange={(e: any) => props.onParticipantWitnessChange(e, 'participant5', 'age', true)} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.participant5 && props.sueData.participant5.identityNumber} onChange={(e: any) => props.onParticipantWitnessChange(e, 'participant5', 'identityNumber', true)} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">

                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.participant5 && props.sueData.participant5.phone} onChange={(e: any) => props.onParticipantWitnessChange(e, 'participant5', 'phone', true)} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.participant5 && props.sueData.participant5.hospitalName} onChange={(e: any) => props.onParticipantWitnessChange(e, 'participant5', 'hospitalName')} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="parameter-row">
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.participant6 && props.sueData.participant6.name} onChange={(e: any) => props.onParticipantWitnessChange(e, 'participant6', 'name')} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">

                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.participant6 && props.sueData.participant6.address} onChange={(e: any) => props.onParticipantWitnessChange(e, 'participant6', 'address')} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.participant6 && props.sueData.participant6.age} onChange={(e: any) => props.onParticipantWitnessChange(e, 'participant6', 'age', true)} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.participant6 && props.sueData.participant6.identityNumber} onChange={(e: any) => props.onParticipantWitnessChange(e, 'participant6', 'identityNumber', true)} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">

                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.participant6 && props.sueData.participant6.phone} onChange={(e: any) => props.onParticipantWitnessChange(e, 'participant6', 'phone', true)} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.participant6 && props.sueData.participant6.hospitalName} onChange={(e: any) => props.onParticipantWitnessChange(e, 'participant6', 'hospitalName')} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                </div>

            </section>
            <section className='with-top-border'>
                <div className='section-sue-title'>
                    פרטי העדים
                </div>
                {/* make this line dynamic, so it can be used for more participants 
                when click on + add new participant limited to 2 participants */}
                <div className="parameter-row">
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                שם עד
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.sueWitness1 && props.sueData.sueWitness1.name} onChange={(e: any) => props.onParticipantWitnessChange(e, 'sueWitness1', 'name')} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                כתובת
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.sueWitness1 && props.sueData.sueWitness1.address} onChange={(e: any) => props.onParticipantWitnessChange(e, 'sueWitness1', 'address')} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                הקרבה לנהג/מבוטח
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.sueWitness1 && props.sueData.sueWitness1.relation} onChange={(e: any) => props.onParticipantWitnessChange(e, 'sueWitness1', 'relation')} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                טלפון
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.sueWitness1 && props.sueData.sueWitness1.phone} onChange={(e: any) => props.onParticipantWitnessChange(e, 'sueWitness1', 'phone', true)} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                נייד
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.sueWitness1 && props.sueData.sueWitness1.mobile} onChange={(e: any) => props.onParticipantWitnessChange(e, 'sueWitness1', 'mobile', true)} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="parameter-row">
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.sueWitness2 && props.sueData.sueWitness2.name} onChange={(e: any) => props.onParticipantWitnessChange(e, 'sueWitness2', 'name')} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.sueWitness2 && props.sueData.sueWitness2.address} onChange={(e: any) => props.onParticipantWitnessChange(e, 'sueWitness2', 'address')} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.sueWitness2 && props.sueData.sueWitness2.relation} onChange={(e: any) => props.onParticipantWitnessChange(e, 'sueWitness2', 'relation')} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">

                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.sueWitness2 && props.sueData.sueWitness2.phone} onChange={(e: any) => props.onParticipantWitnessChange(e, 'sueWitness2', 'phone', true)} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">

                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.sueWitness2 && props.sueData.sueWitness2.mobile} onChange={(e: any) => props.onParticipantWitnessChange(e, 'sueWitness2', 'mobile', true)} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default VictimsAndWitnesses